export default function ContactSection() {
  return (
    <section className="w-full px-10 pb-10">
      <div className="rounded-[36px] bg-background-900 px-[100px] py-[100px]">
        <div className="w-full h-px bg-white/8 mb-[80px]" />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-[60px] gap-y-10">
          <div>
            <h4
              className="text-xs font-semibold text-white tracking-[0.1em] uppercase mb-7 whitespace-nowrap"
              style={{ fontFamily: "var(--font-label)" }}
            >
              Location
            </h4>
            <div
              className="text-[14px] font-normal text-foreground-300 leading-[2.4]"
              style={{ fontFamily: "var(--font-body)" }}
            >
              <p>956 Chem Moncrieff</p>
              <p>Mont-Royal</p>
              <p>H3R 3A4</p>
              <p>Canada</p>
            </div>
          </div>

          <div>
            <h4
              className="text-xs font-semibold text-white tracking-[0.1em] uppercase mb-7 whitespace-nowrap"
              style={{ fontFamily: "var(--font-label)" }}
            >
              Telephone
            </h4>
            <p
              className="text-[14px] font-normal text-foreground-300"
              style={{ fontFamily: "var(--font-body)" }}
            >
              +1 2367055989
            </p>
          </div>

          <div>
            <h4
              className="text-xs font-semibold text-white tracking-[0.1em] uppercase mb-7 whitespace-nowrap"
              style={{ fontFamily: "var(--font-label)" }}
            >
              Electronic Mail
            </h4>
            <p
              className="text-[14px] font-normal text-foreground-300"
              style={{ fontFamily: "var(--font-body)" }}
            >
              co@tksoftwareflow.com
            </p>
          </div>

          <div className="lg:text-right">
            <p
              className="text-[56px] font-light text-foreground-200 leading-[1.1]"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              &copy; 2025
            </p>
            <p
              className="text-[13px] font-normal text-foreground-600 mt-2"
              style={{ fontFamily: "var(--font-body)" }}
            >
              All rights reserved.
            </p>
          </div>
        </div>

        <div className="mt-[100px] w-full lg:w-[65%]">
          <p
            className="text-[40px] font-light text-foreground-600 leading-[1.3]"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            Technical Excellence
            <br />
            Without
            <br />
            Compromise
          </p>
        </div>
      </div>
    </section>
  );
}